import React, { useState, useEffect } from "react";
import { NavLink, useNavigate, Link, useLocation } from "react-router-dom";
import styles from "../styles/sidebar.module.css";
import { useAuth } from "../context/AuthContext";
import { useResumeBuilder } from "../context/ResumeBuilderContext";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout: contextLogout } = useAuth();
  const {
    setIsConfigModalOpen,
    setIsPreviewVisible,
    isPreviewVisible,
    triggerDemoLoad,
    triggerCustomSection,
    triggerDownload,
    triggerSaveAndUse,
    triggerNewResume,
    resumeName,
    setResumeName,
  } = useResumeBuilder();
  const isInterviewPath = location.pathname.startsWith("/dashboard/interview-");
  const [isInterviewMenuOpen, setIsInterviewMenuOpen] =
    useState(isInterviewPath);
  const isResumeBuilderPath = location.pathname.startsWith(
    "/dashboard/resume-builder"
  );
  const [isBuilderMenuOpen, setIsBuilderMenuOpen] =
    useState(isResumeBuilderPath);
  const handleInterviewMenuClick = (e) => {
    // Agar pehle se interview pages par nahi hain, to seedha navigate karo
    if (!isInterviewPath) {
      navigate("/dashboard/interview-assistant");
    } else {
      // Agar pehle se hain, to sirf submenu ko toggle karo
      e.preventDefault();
      setIsInterviewMenuOpen((prev) => !prev);
    }
  };

  const handleResumeBuilderClick = (e) => {
    if (!isResumeBuilderPath) {
      navigate("/dashboard/resume-builder");
    } else {
      e.preventDefault();
      setIsBuilderMenuOpen((prev) => !prev);
    }
  };

  // useEffect(() => {
  //   setIsBuilderMenuOpen(isResumeBuilderPath);
  // }, [isResumeBuilderPath]);
  useEffect(() => {
    // setIsInterviewMenuOpen(
    //   location.pathname.startsWith("/dashboard/interview-")
    // );
    setIsBuilderMenuOpen(
      location.pathname.startsWith("/dashboard/resume-builder")
    );
  }, [location.pathname]);

  return (
    <div
      className={`${styles.sidebar} ${isOpen ? styles.open : styles.closed}`}
    >
      <div className={styles.sidebarHeader}>
        {isOpen && (
          <Link to="/" className={styles.navLogo}>
            <img
              src="/icon1.ico"
              alt="Job Assistant Logo"
              className={styles.logoImage}
            />
            <div className={styles.logoText}>
              <span className={styles.logoJob}>Job</span>
              <span className={styles.logoAssistant}>Assistant</span>
            </div>
          </Link>
        )}
        <button onClick={toggleSidebar} className={styles.toggleButton}>
          <i
            className={`fas ${
              isOpen ? "fa-angle-double-left" : "fa-angle-double-right"
            }`}
          ></i>
        </button>
      </div>

      <nav className={styles.sidebarNav}>
        <ul>
          <li>
            <NavLink
              to="/dashboard"
              className={({ isActive }) =>
                `${styles.navLink} ${
                  isActive && !isResumeBuilderPath ? styles.activeLink : ""
                }`
              }
              end
            >
              <i className="fas fa-tachometer-alt"></i>
              {isOpen && <span>Dashboard</span>}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/dashboard/setup"
              className={({ isActive }) =>
                `${styles.navLink} ${isActive ? styles.activeLink : ""}`
              }
            >
              <i className="fas fa-cogs"></i>
              {isOpen && <span>Assistant Setup</span>}
            </NavLink>
          </li>

          <li className={styles.navItemWithSubmenu}>
            <NavLink
              to="/dashboard/resume-builder"
              onClick={handleResumeBuilderClick}
              className={`${styles.navLink} ${
                isResumeBuilderPath ? styles.activeLink : ""
              }`}
            >
              <i className="fas fa-file-alt"></i>
              {isOpen && <span>Resume Builder</span>}
              {isOpen && (
                <i
                  className={`fas fa-chevron-up ${styles.arrowIcon} ${
                    isBuilderMenuOpen ? styles.arrowOpen : ""
                  }`}
                ></i>
              )}
            </NavLink>

            {isOpen && (
              <div
                className={`${styles.navSubMenu} ${
                  isBuilderMenuOpen ? styles.subMenuOpen : ""
                }`}
              >
                <div className={styles.sidebarFormGroup}>
                  <label>RESUME TITLE</label>
                  <input
                    type="text"
                    value={resumeName}
                    onChange={(e) => setResumeName(e.target.value)}
                  />
                </div>
                <hr className={styles.sidebarDivider} />

                <button
                  onClick={triggerNewResume}
                  className={styles.subMenuItem}
                >
                  <i className="fas fa-plus"></i> Create New Resume
                </button>
                <button
                  onClick={triggerCustomSection}
                  className={styles.subMenuItem}
                >
                  <i className="fas fa-plus-circle"></i> Custom Section
                </button>
                <button
                  onClick={() => setIsConfigModalOpen(true)}
                  className={styles.subMenuItem}
                >
                  <i className="fas fa-palette"></i> Set Layout
                </button>
                <button
                  onClick={() => setIsPreviewVisible((prev) => !prev)}
                  className={styles.subMenuItem}
                >
                  <i
                    className={`fas ${
                      isPreviewVisible ? "fa-eye-slash" : "fa-eye"
                    }`}
                  ></i>
                  {isPreviewVisible ? "Hide Preview" : "Show Preview"}
                </button>
                <button
                  onClick={triggerDownload}
                  className={styles.subMenuItem}
                >
                  <i className="fas fa-download"></i> Download PDF
                </button>
                <button
                  onClick={triggerDemoLoad}
                  className={styles.subMenuItem}
                >
                  <i className="fas fa-pencil-ruler"></i> Load Demo
                </button>
                <hr className={styles.sidebarDivider} />

                <button
                  className={styles.subMenuItem}
                  onClick={triggerSaveAndUse}
                >
                  <i className="fas fa-robot"></i> Set for Automation
                </button>
              </div>
            )}
          </li>

          <li>
            <a
              href="https://microsoftedge.microsoft.com/addons/detail/job-assistant/djinbdjbkbanilepgcdgbnenojpojadb"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.navLink}
            >
              <i className="fas fa-puzzle-piece"></i>
              {isOpen && <span>Get Extension</span>}
            </a>
          </li>
        </ul>
      </nav>

      <div className={styles.sidebarFooter}>
        {!user?.isPremium && isOpen && (
          <button
            className={styles.upgradeButton}
            onClick={() => navigate("/pricing")}
          >
            <i className="fas fa-crown"></i> <span>Upgrade Plan</span>
          </button>
        )}
        <div className={styles.userInfo}>
          {isOpen ? (
            <>
              <div className={styles.avatar}>
                {user?.email ? user.email.charAt(0).toUpperCase() : "G"}
              </div>
              <div className={styles.userDetails}>
                <span className={styles.userName}>
                  {user?.displayName || user?.email || "Guest User"}
                </span>
                {user?.isPremium && (
                  <span className={styles.premiumBadge}>Premium</span>
                )}
              </div>
            </>
          ) : (
            <div className={`${styles.avatar} ${styles.avatarClosed}`}>
              {user?.email ? user.email.charAt(0).toUpperCase() : "G"}
            </div>
          )}
        </div>
        <button onClick={contextLogout} className={styles.logoutButton}>
          <i className="fas fa-sign-out-alt"></i>
          {isOpen && <span>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
